import { fetcher } from "../../../../../api";
import { Picture, UrlInterface } from "../../../../../types";
import { createFakeSrcSetObject } from "../../../../../utils";

export enum AppNames {
  aad = "askADoctorUrl",
  community = "communityUrl",
  dovehub = "dovehubsUrl"
}

export const fetchParticipations = (url: UrlInterface | undefined | null) => {
  if (url) {
    const { method, url: actionUrl } = url;
    return fetcher({
      method,
      url: actionUrl,
      authTokenRequired: false
    }).then((res) => {
      return res as {
        [AppNames.community]: UrlInterface,
        [AppNames.aad]: UrlInterface,
        [AppNames.dovehub]: UrlInterface,
      };
    }).catch(() => {
      return null;
    })
  }
  return Promise.reject(() => {
    return null;
  })
}

export const fetchAskADoctorParticipations = (url: UrlInterface) => {
  const { method, url: actionUrl } = url;
  return fetcher({
    method,
    url: actionUrl,
    authTokenRequired: false
  }).then((res: {
    displayName: string;
    userSpeciality: string,
    picture: {
      path: string | null;
    },
    answersCount: number;
    id: number;
  }) => {
    const {
      displayName,
      userSpeciality, 
      picture,
      answersCount,
      id
    } = res;
    return {
      name: displayName,
      speciality: userSpeciality,
      picture: createFakeSrcSetObject(picture.path),
      answersCount,
      redirectUrl: `/ask-a-doctor/profile/${id}`
    }
  }).catch(() => {
    return null;
  })
}

export const fetchDoveHubParticipations = (url: UrlInterface) => {
  const { method, url: actionUrl } = url;
  return fetcher({
    method,
    url: actionUrl,
    authTokenRequired: false
  }).then((res) => {
    return {
      ...res,
      results: res.results.map((each: { hubName: string, picture: Picture | null, id: string }) => {
        return {
          name: each.hubName,
          picture: each.picture,
          redirectUrl: `/dovehub/hub-info/${each.id}`
        }
      })
    }
  }).catch(() => {
    return {
      results: [],
      count: 0
    }
  })
}

export const fetchDoveCommunitiesParticipations = (url: UrlInterface) => {
  const { method, url: actionUrl } = url;
  return fetcher({
    method,
    url: actionUrl,
    authTokenRequired: false
  }).then((res) => {
    return {
      ...res,
      results: res.results.map((each: { communityName: string, picture: Picture | null, uuid: string }) => {
        return {
          name: each.communityName,
          picture: each.picture,
          redirectUrl: `/community/community/${each.uuid}`
        }
      })
    }
  }).catch(() => {
    return {
      results: [],
      count: 0
    }
  })
}
